import WithAdditionalValidationState from 'components/WithAdditionalValidation/WithAdditionalValidationState';
import InputFields from './components/InputFields';
import ModalWindows from './components/ModalWindows/ModalWindows';
import React from 'react';
import classNames from 'classnames';
import style from './BankSettingsForm.module.scss';

interface IBankSettingsForm {
	isVisible: boolean;
}

const BankSettingsForm: React.FC<IBankSettingsForm> = ({ isVisible }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses}>
			<WithAdditionalValidationState>
				<InputFields />
			</WithAdditionalValidationState>
			<ModalWindows />
		</div>
	);
};

export default React.memo(BankSettingsForm);
